import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { cn } from '../../utils/cn';

interface ViewToggleProps {
  view: 'grid' | 'list';
  onViewChange: (view: 'grid' | 'list') => void;
}

export default function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  return (
    <div className="flex bg-dark-800 rounded-lg p-1">
      <button
        onClick={() => onViewChange('grid')}
        className={cn(
          'p-2 rounded-md transition-colors',
          view === 'grid' ? 'bg-primary-600 text-white' : 'text-gray-400 hover:text-white'
        )}
        title="Grid view"
      >
        <LayoutGrid className="w-5 h-5" />
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={cn(
          'p-2 rounded-md transition-colors',
          view === 'list' ? 'bg-primary-600 text-white' : 'text-gray-400 hover:text-white'
        )}
        title="List view"
      >
        <List className="w-5 h-5" />
      </button>
    </div>
  );
}